/* Local presentation only: keep shared controls and other workspaces unchanged. */
.data-manager-create-field-error > span:last-child {
  color: #a61b36;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
}

.data-manager-tabs-bar,
.data-manager-tabs-actions {
  padding: 6px 10px;
  border-radius: 4px;
  background: #191613;
  color: white;
}

.data-manager-tabs-actions .data-manager-tabs-bar {
  padding: 0;
}

.data-manager-tabs-bar > div > span {
  color: #dde5e8;
}

/* Give toolbar controls a visible hover and keyboard focus state. */
.data-manager-tabs-bar button.bg-white:not(:disabled):is(:hover, :focus-visible),
.data-manager-tabs-actions > button:not(:disabled):is(:hover, :focus-visible) {
  background-color: #ccebe5;
  border-color: var(--color-accent);
  color: var(--color-accent-strong);
  cursor: pointer;
}
.data-manager-tabs-bar select {
  color: var(--color-slate-700);
}

[data-mobile-workspace="data-manager"] :is([class^="rounded"], [class*=" rounded"]):not(.rounded-none, .animate-spin, img, svg, input[type="radio"]) {
  border-radius: 4px;
}

[data-mobile-workspace="data-manager"] span.rounded-full.h-2.w-2 {
  border-radius: 0;
}

/* Same compact banner as Reports and Import; the data workspace stays full width. */
[data-mobile-workspace="data-manager"] .data-manager-hero {
  container: data-manager-hero / inline-size;
  position: relative;
  isolation: isolate;
  min-height: 72px;
  padding: 6px 20px;
  overflow: clip;
  border: 1px solid var(--color-line-soft);
  border-radius: 4px;
  background: white;
}

.data-manager-hero::before {
  position: absolute;
  z-index: -1;
  inset: 0 0 0 auto;
  width: 54%;
  max-width: 434px;
  content: "";
  background-image: url("/brand/reports/transia-grain-banner.png");
  background-position: right center;
  background-size: auto 100%;
  background-repeat: no-repeat;
  mask-image: linear-gradient(90deg, transparent 10%, rgb(0 0 0 / 0.025) 18%, rgb(0 0 0 / 0.10) 26%, rgb(0 0 0 / 0.30) 34%, rgb(0 0 0 / 0.60) 42%, rgb(0 0 0 / 0.86) 48%, black 56%);
}

.data-manager-hero > div {
  align-items: center;
  padding-right: clamp(330px, 32cqw, 440px);
}

.data-manager-hero h1 {
  font-size: clamp(24px, 2.2cqw, 28px);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.035em;
}

.data-manager-hero [aria-hidden='true']:has(> svg) {
  width: 32px;
  height: 32px;
}

.data-manager-hero [aria-hidden='true'] > svg {
  width: 20px;
  height: 20px;
}

.data-manager-hero-subtitle {
  display: block;
  margin-top: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--color-slate-800);
}

@media (max-width: 979px) {
  [data-mobile-workspace="data-manager"] .data-manager-hero {
    min-height: 0;
    padding: 12px 16px;
  }

  .data-manager-hero::before {
    display: none;
    background-image: none;
  }

  .data-manager-hero > div {
    padding-right: 0;
  }
}

@container data-manager-hero (max-width: 719px) {
  .data-manager-hero [aria-hidden='true']:has(> svg) {
    width: 40px;
    height: 40px;
  }

  .data-manager-hero-subtitle {
    font-size: 15px;
  }
}


/* Admin transfers stay available without taking space from the active table. */
.data-manager-admin-transfer > summary {
  cursor: pointer;
  color: var(--color-slate-700);
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
}
.data-manager-admin-transfer > summary:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 4px;
  border-radius: 4px;
}
.data-manager-admin-transfer[open] > summary { margin-bottom: 10px; }

@media (min-width: 1281px) {
  [data-mobile-workspace="data-manager"] { padding-right: 1rem; }

  /* The shell supplies the available height; only table rows scroll by default.
     Order creation and expanded admin/history content keep normal page scrolling. */
  [data-manager-viewport="true"]:has(.data-manager-viewport-grid):not(:has(> details[open], .data-manager-create-order-form)) {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
  }

  [data-manager-viewport="true"]:not(:has(> details[open], .data-manager-create-order-form)) > article:has(.data-manager-viewport-grid),
  [data-manager-viewport="true"]:not(:has(> details[open], .data-manager-create-order-form)) .data-manager-viewport-panel {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
  }

  [data-manager-viewport="true"]:not(:has(> details[open], .data-manager-create-order-form)) > *,
  [data-manager-viewport="true"]:not(:has(> details[open], .data-manager-create-order-form)) > article:has(.data-manager-viewport-grid) > :not(.data-manager-viewport-grid, .data-manager-viewport-panel),
  [data-manager-viewport="true"]:not(:has(> details[open], .data-manager-create-order-form)) .data-manager-viewport-panel > :not(.data-manager-viewport-grid, .data-manager-viewport-panel) {
    flex-shrink: 0;
  }

  [data-manager-viewport="true"]:not(:has(> details[open], .data-manager-create-order-form)) .data-manager-viewport-grid {
    flex: 1 1 auto;
    min-height: 140px;
    max-height: none;
    overflow: auto;
  }
}

/* Champ du dompeur sur une autre ligne de Camions : vide et non modifiable. */
.data-manager-cell-off {
  background-image: repeating-linear-gradient(135deg, transparent 0 6px, rgb(148 163 184 / 0.1) 6px 12px);
}
